var _desc, _defs, _path, _path2, _path3, _path4, _use, _use2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustration4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "279px",
    height: "140px",
    viewBox: "0 0 279 140",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "illustration-4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-1",
    width: 4,
    height: 4,
    x: 246,
    y: 23,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image-2"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image-2",
    width: 4,
    height: 4,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAABGdBTUEAALGOfPtRkwAAAB1JREFUCB1j/A8EDBDACKKYoBw4xQJkgWVgIhgqAAb3BAgldYidAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,139.5 L256.5,139.5",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 256,
    height: 1,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M125.5,14.5 L280.5,14.5",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 155,
    height: 1,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Features-2",
    transform: "translate(-100.000000, -114.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illustration-4",
    transform: "translate(100.000000, 114.000000)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5,126.5 L249.5,126.5 L249.5,0.5 L0.5,0.5 L0.5,126.5 Z",
    id: "Stroke-1",
    stroke: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.5,126.5 L278.5,126.5 L278.5,27.5 L122.5,27.5 L122.5,126.5 Z",
    id: "Stroke-2",
    stroke: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "url(#pattern-1)",
    style: {
      mixBlendMode: "exclusion"
    },
    opacity: 0.200000003,
    points: "250 27 279 27 279 127 250 127"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.809,103.32935 L27.809,111.68135 L29.361,111.68135 L29.361,100.86535 L28.337,100.86535 C28.161,101.48935 27.841,101.90535 27.377,102.09735 C26.9516667,102.27335 26.244,102.368683 25.2786481,102.38335 L24.529,102.38535 L24.529,103.32935 L27.809,103.32935 Z M42.1338,108.24135 C42.1338,106.19335 40.4698,104.99335 37.4138,104.99335 C36.4698,104.99335 35.5898,105.15335 34.7898,105.48935 C33.9898,105.82535 33.3498,106.16135 32.8538,106.52935 C32.8538,105.18535 33.2858,104.09735 34.1338,103.28135 C34.9818,102.46535 36.1818,102.06535 37.7338,102.06535 C39.2698,102.06535 40.2938,102.41735 41.2058,102.81735 L41.6858,101.60135 C40.4538,101.07335 39.2378,100.76935 37.7018,100.76935 C33.7338,100.76935 31.3338,103.16935 31.3338,106.70535 C31.3338,109.82535 33.3658,111.93735 37.0298,111.93735 C40.3578,111.93735 42.1338,110.20935 42.1338,108.24135 Z M37.2378,106.08135 C39.0458,106.08135 40.6138,106.65735 40.6138,108.19335 C40.6138,109.80935 39.0618,110.65735 37.0458,110.65735 C34.9818,110.65735 33.3178,109.71335 32.9338,107.66535 C33.8938,106.84935 35.3818,106.08135 37.2378,106.08135 Z M43.0506,105.98535 L45.0026,105.98535 L45.0026,104.33735 L43.0506,104.33735 L43.0506,105.98535 Z M43.0506,111.68135 L45.0026,111.68135 L45.0026,110.03335 L43.0506,110.03335 L43.0506,111.68135 Z M56.7194,106.00135 C56.7194,102.78535 54.5114,100.76935 51.0234,100.76935 C47.6954,100.76935 45.9354,102.51335 45.9354,104.52935 C45.9354,106.59335 47.5834,107.82535 50.6394,107.82535 C51.5834,107.82535 52.4634,107.66535 53.2634,107.32935 C54.0634,107.00935 54.7034,106.65735 55.1994,106.28935 C55.1354,108.96135 53.3914,110.65735 50.3354,110.65735 C48.7994,110.65735 47.6794,110.28935 46.3994,109.69735 L45.9354,110.91335 C47.5194,111.61735 48.8154,111.93735 50.3674,111.93735 C54.3514,111.93735 56.7194,109.53735 56.7194,106.00135 Z M47.4554,104.56135 C47.4554,102.89735 49.0074,102.03335 51.0074,102.03335 C53.1674,102.03335 54.7994,103.10535 55.1354,105.15335 C54.1754,105.93735 52.6874,106.73735 50.8314,106.73735 C49.0234,106.73735 47.4554,106.16135 47.4554,104.56135 Z",
    id: "16:9",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.400000006
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M147.761,107.82535 L147.761,109.00935 L155.841,109.00935 L155.841,111.68135 L157.313,111.68135 L157.313,109.00935 L159.617,109.00935 L159.617,107.80935 L157.313,107.80935 L157.313,101.02535 L155.553,101.02535 L147.761,107.82535 Z M149.585,107.80935 L155.841,102.32135 L155.841,107.80935 L149.585,107.80935 Z M161.073,105.98535 L163.025,105.98535 L163.025,104.33735 L161.073,104.33735 L161.073,105.98535 Z M161.073,111.68135 L163.025,111.68135 L163.025,110.03335 L161.073,110.03335 L161.073,111.68135 Z M170.481,100.76935 C173.745,100.76935 175.265,102.12935 175.265,103.71335 C175.265,104.88135 174.433,105.90535 172.273,106.30535 C173.441,106.51335 174.241,106.83335 174.673,107.29735 C175.105,107.76135 175.313,108.28935 175.313,108.84935 C175.313,110.41735 173.617,111.93735 170.273,111.93735 C168.273,111.93735 166.593,111.52135 164.913,110.64135 L165.441,109.44135 C166.977,110.25735 168.577,110.64135 170.161,110.64135 C172.513,110.64135 173.681,109.85735 173.681,108.70535 C173.681,107.44135 172.225,106.91335 169.937,106.91335 L168.033,106.91335 L168.033,105.74535 L169.937,105.74535 C172.449,105.74535 173.681,105.08935 173.681,103.92135 C173.681,102.78535 172.497,102.06535 170.433,102.06535 C168.833,102.06535 167.265,102.54535 165.921,103.29735 L165.377,102.09735 C167.105,101.21735 168.673,100.76935 170.481,100.76935 Z",
    id: "4:3",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.400000006
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Stroke-3",
    stroke: "#FFFFFF",
    mask: "url(#mask-4)",
    strokeWidth: 2,
    opacity: 0.400000006,
    strokeDasharray: 3,
    xlinkHref: "#path-3"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    id: "Stroke-4",
    stroke: "#FFFFFF",
    mask: "url(#mask-6)",
    strokeWidth: 2,
    opacity: 0.400000006,
    strokeDasharray: 3,
    xlinkHref: "#path-5"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration4);
export default __webpack_public_path__ + "static/media/illustration-4.8d468d76eb68c2ac241b0ee97bd5beb5.svg";
export { ForwardRef as ReactComponent };